/* src/app/admin/popi/mappings/create-or-update-mapping/create-or-update-mapping.component.scss */
.mapping-container {
  padding: 20px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.config-button {
  background-color: #006f8a;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.fields-section {
  margin-top: 30px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
th,
td {
  padding: 10px;
  border: 1px solid #ddd;
}
th {
  background-color: #006f8a;
  color: white;
}
.button-bar {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}
.save-button,
.cancel-button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.save-button {
  background-color: #28a745;
  color: white;
}
.cancel-button {
  background-color: #dc3545;
  color: white;
}
.form-columns {
  display: flex;
  gap: 40px;
  margin-bottom: 20px;
}
.left-column,
.right-column {
  flex: 1;
}
/*# sourceMappingURL=create-or-update-mapping.component-FETR2YGQ.css.map */
